<template>
  <div style="height: 100%; background: white; padding: 10px">
    <Tabs v-model="tab" @on-click="tabChange">
      <TabPane
        v-for="item in tabs"
        :label="item.label"
        :name="item.value"
        :key="item.value"
      >
        <Order
          v-if="item.order"
          style="height: calc(100vh - 200px)"
          :data="tabsData[item.value]"
          :headers="header"
          :name="item.value"
          :ref="item.value"
        ></Order>
        <Char
          v-else-if="item.char"
          style="height: calc(100vh - 200px)"
          :data="tabsData[item.value]"
          :headers="header"
          :name="item.value"
          :ref="item.value"
        ></Char>
        <Custom
          v-else
          style="height: calc(100vh - 200px)"
          :data="tabsData[item.value]"
          :type="item.value"
          :headers="header"
          :name="item.value"
          :ref="item.value"
          :noPage="item.noPage"
        ></Custom>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import Order from "./order";
import Custom from "./custom";
import Char from "./char";

import { apis } from "@/api/analysis/financialRevenue";
import { optionsApi, optionsCommonApi } from "@/libs/api.request.js";

export default {
  name: "financialRevenue",
  components: {
    Order,
    Custom,
    Char
  },
  mounted() {
    optionsCommonApi(
      this.header.reduce((a, b) => {
        if (b.options && !b.options.length) {
          b.optionsKey && a.set(b, b.optionsKey);
          b.optionsFn && optionsApi(b, b.optionsFn);
        }
        return a;
      }, new Map())
    );
    setTimeout(() => {
      this.tabChange(this.tab);
    }, 100);
  },
  methods: {
    tabChange(e) {
      if (this.$refs[e][0].init) return;
      this.$refs[e][0].init = true;
      this.$refs[e][0].$refs.table.getList();
    }
  },
  data() {
    return {
      tab: "char",
      tabs: [
        {
          label: this.$tz("树状图"),
          char: true,
          value: "char"
        },
        {
          label: this.$tz("汇总"),
          order: true,
          value: "time"
        },
        {
          label: this.$tz("合同,主体"),
          order: true,
          value: "contract"
        },
        {
          label: this.$tz("明细"),
          custom: true,
          value: "detail"
        },
        {
          label: this.$tz("排行榜"),
          custom: true,
          noPage: true,
          value: "rank"
        }
      ],
      tabsData: {
        char: {
          list: apis.histogram
        },
        time: {
          list: apis.time
        },
        contract: {
          list: apis.contract
        },
        detail: {
          list: apis.detail,
          keys: {
            airway_number: {
              type: "string",
              description: "运单号"
            },
            client: { type: "string", description: "客户名" },
            company: { type: "string", description: "公司名称" },
            order_type: { type: "string", description: "订单类型" },
            from_country: { type: "string", description: "起运国" },
            to_country: { type: "string", description: "目的国" },
            sale: { type: "string", description: "业务" },
            charge_weight: {
              type: "string",
              description: "计费重"
            },
            bill_time: { type: "string", description: "账单时间" },
            income: { type: "string", description: "账单金额" },
            income_currency: {
              type: "string",
              description: "账单币种"
            }
          }
        },
        rank: {
          list: apis.rank,
          keys: {
            name: { type: "string", description: "排行,信息" },
            num: { type: "string", description: "订单,数量" },
            income: { type: "string", description: "收入" },
            currency: { type: "string", description: "币种" }
          }
        }
      },
      header: [
        {
          key: "statType",
          placeholder() {
            return this.$tz("统计,维度");
          },
          component: "Select",
          options: [],
          includes: ["char", "time", "contract"],
          optionsFn: "",
          optionsKey: "FINANCE_DATE_SELECT_TYPE",
          noAuto: true
        },
        {
          key: "startTime",
          placeholder() {
            return this.$tz("请选择,开始,日期");
          },
          component: "DatePicker",
          bind: {
            options: {
              disabledDate(time) {
                return time.getTime() > Date.now();
              }
            },
            style: {
              width: "150px"
            }
          },
          default: new Date(
            new Date(new Date().setDate(1)).setHours(0, 0, 0, 0)
          )
        },
        {
          key: "endTime",
          placeholder() {
            return this.$tz("请选择,结束,日期");
          },
          component: "DatePicker",
          bind: {
            options: {
              disabledDate(time) {
                return time.getTime() > Date.now();
              }
            },
            style: {
              width: "150px"
            }
          },
          default: new Date(new Date().setHours(23, 59, 59, 59)),
          noAuto: true
        },
        {
          key: "client_id",
          placeholder() {
            return this.$tz("客户名称");
          },
          component: "Select",
          options: [],
          optionsFn: "getAllClient",
          optionsKey: "",
          noAuto: true
        },
        {
          key: "order_type",
          placeholder() {
            return this.$tz("订单类型");
          },
          component: "Select",
          options: [],
          optionsFn: "",
          optionsKey: "ORDERS_TYPE",
          noAuto: true,
          bind: {
            multiple: true
          }
        },
        {
          key: "from_country",
          placeholder() {
            return this.$tz("起运国家");
          },
          component: "Select",
          options: [],
          optionsFn: "formCountry",
          optionsKey: "",
          noAuto: true
        },
        {
          key: "to_country",
          placeholder() {
            return this.$tz("目的国家");
          },
          component: "Select",
          options: [],
          optionsFn: "toCountry",
          optionsKey: "",
          noAuto: true
        },
        {
          key: "contract_id",
          placeholder() {
            return this.$tz("合同抬头");
          },
          component: "Select",
          options: [],
          optionsFn: "contractParam",
          optionsKey: ""
        },
        {
          key: "ownership",
          placeholder() {
            return this.$tz("所属公司");
          },
          component: "Select",
          options: [],
          optionsFn: "getCompanies",
          optionsKey: ""
        },
        {
          key: "sale_id",
          placeholder() {
            return this.$tz("业务员");
          },
          component: "Select",
          options: [],
          optionsFn: "salesman",
          optionsKey: ""
        },
        {
          key: "sortType",
          placeholder() {
            return this.$tz("排序,类型");
          },
          component: "Select",
          options: [],
          includes: ["rank"],
          optionsFn: "getCommon",
          optionsKey: "",
          apiData: {
            apiType: "sortType"
          }
        },
        {
          key: "limitNum",
          placeholder() {
            return this.$tz("展示,数量");
          },
          component: "Input",
          includes: ["rank"]
        },
        {
          key: "rankType",
          placeholder() {
            return this.$tz("排行榜,维度");
          },
          component: "Select",
          options: [],
          includes: ["rank"],
          optionsFn: "getCommon",
          optionsKey: "",
          apiData: {
            apiType: "rankType"
          }
        }
      ]
    };
  }
};
</script>

<style></style>
